import accounts from "accounts/Accounts.js";

export const getSamplesStream = (tags, guildIds=[0.0], isFavorited=false) => {
    return new Promise(async (resolve, reject) => {
        if (window.isNFT) {
            resolve([]);
            return;
        }
        let user = await accounts.getAccount();
        fetch('/samplesStream/' , {
            method: 'POST',
            body: JSON.stringify({andTags: tags, guildIds, isFavorited: isFavorited, user}),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                resolve(resp.ids);
            });
    });
}
